/**
 * MS-1095: Parent form → child form table copy (admin).
 * Data source: enriched field.item_id_parent (input_table from formItemParent).
 */
import * as InputMethods from '@/core/config/InputMethods';

const EXCLUDED_Y_INPUT_METHODS_FOR_COPY = [
    InputMethods.INPUT_METHOD_FILE,
    InputMethods.INPUT_METHOD_LABEL,
];

export function parseCopyId(copyId) {
    if (!copyId) {
        return null;
    }
    if (typeof copyId === 'string') {
        const match = copyId.match(/\d+$/);
        return match ? parseInt(match[0], 10) : parseInt(copyId, 10);
    }
    return copyId;
}

export function isFormCopyEnabled(formBase) {
    return !!(formBase && formBase.parent_form_id && formBase.copy_flag);
}

export function parseInputTableDefinition(inputTable) {
    if (!inputTable || inputTable === '' || Array.isArray(inputTable)) {
        return null;
    }
    if (typeof inputTable === 'string') {
        try {
            return JSON.parse(inputTable);
        } catch (e) {
            return null;
        }
    }
    return inputTable;
}

export function enrichItemIdParentWithFormItemParent(itemIdParent, formItemParent) {
    if (!Array.isArray(itemIdParent)) {
        return itemIdParent;
    }
    if (!Array.isArray(formItemParent) || !formItemParent.length) {
        return itemIdParent;
    }
    return itemIdParent.map((ref) => {
        if (!ref || ref.input_table) {
            return ref;
        }
        const fullItem = formItemParent.find((item) => item && item.item_id == ref.item_id);
        if (!fullItem || !fullItem.input_table) {
            return ref;
        }
        return { ...ref, input_table: fullItem.input_table };
    });
}

export function resolveParentTableItemForCopy(copyId, field) {
    const isParentTableItem = (item) => {
        return item
            && item.item_id == copyId
            && item.input_method === InputMethods.INPUT_METHOD_TABLE;
    };
    const itemIdParent = field && Array.isArray(field.item_id_parent)
        ? field.item_id_parent
        : [];
    return itemIdParent.find(isParentTableItem) || null;
}

export function isAllowedInputMethodForTableCopy(yItem) {
    if (!yItem || yItem.input_method === null || yItem.input_method === undefined) {
        return false;
    }
    return !EXCLUDED_Y_INPUT_METHODS_FOR_COPY.includes(Number(yItem.input_method));
}

export function getParentTableYItemsForCopy(yItem, context) {
    const { field, formBase } = context || {};
    if (!yItem || !isAllowedInputMethodForTableCopy(yItem)) {
        return [];
    }
    const copyId = parseCopyId(field && field.copy_id);
    if (!copyId) {
        return [];
    }
    const parentTableItem = resolveParentTableItemForCopy(copyId, field);
    if (!parentTableItem || !parentTableItem.input_table) {
        return [];
    }
    const inputTableData = parseInputTableDefinition(parentTableItem.input_table);
    if (!inputTableData || !inputTableData.y_items || !Array.isArray(inputTableData.y_items)) {
        return [];
    }
    const currentInputMethod = Number(yItem.input_method);
    return inputTableData.y_items
        .filter(tableYItem => Number(tableYItem.input_method) === currentInputMethod)
        .map(tableYItem => ({
            field_key: tableYItem.field_key,
            label_name: tableYItem.label_name,
        }));
}

export function canShowTableCopyYSelect(yItem, context) {
    const { field } = context || {};
    if (!isFormCopyEnabled(context && context.formBase)) {
        return false;
    }
    if (!isAllowedInputMethodForTableCopy(yItem)) {
        return false;
    }
    const copyId = parseCopyId(field && field.copy_id);
    if (!copyId) {
        return false;
    }
    const parentTableItem = resolveParentTableItemForCopy(copyId, field);
    return !!(parentTableItem && parentTableItem.input_table);
}
